export const moduleOptions = [
  { key: "billing", label: "Ledger billing", roles: [] },
  { key: "service", label: "Service ops", roles: ["reception", "mechanic", "tester"] },
  { key: "shop", label: "Shop billing", roles: ["shopkeeper"] },
  { key: "inventory", label: "Inventory", roles: [] },
  { key: "hr", label: "HR", roles: [] },
  { key: "loop", label: "Loop chat", roles: [] },
  { key: "payments", label: "Payments", roles: [] },
];

export const allModules = moduleOptions.map((item) => item.key);

export const planPresets = {
  basic: {
    label: "Basic",
    branchLimit: 1,
    staffLimit: 5,
    modules: ["service", "shop", "inventory", "loop", "payments", "billing"],
  },
  terminal_ledger: {
    label: "Mini",
    branchLimit: 1,
    staffLimit: 1,
    modules: ["billing", "payments"],
  },
  terminal_plus: {
    label: "Terminal Plus",
    branchLimit: 1,
    staffLimit: 5,
    modules: allModules,
  },
  pro: {
    label: "Pro",
    branchLimit: 3,
    staffLimit: 25,
    modules: ["service", "shop", "inventory", "hr", "loop", "payments"],
  },
  enterprise: {
    label: "Enterprise",
    branchLimit: 9999,
    staffLimit: 9999,
    modules: allModules,
  },
  custom: {
    label: "Custom",
    branchLimit: 1,
    staffLimit: 5,
    modules: ["shop", "inventory", "loop", "payments", "billing"],
  },
};

export const planOptions = Object.fromEntries(Object.entries(planPresets).map(([key, value]) => [key, value.label]));

export function modulesForPlan(plan) {
  return planPresets[plan]?.modules || planPresets.basic.modules;
}

export function limitsForPlan(plan) {
  const preset = planPresets[plan] || planPresets.basic;
  return { branchLimit: preset.branchLimit, staffLimit: preset.staffLimit };
}

export function enabledModules(source) {
  const raw = source?.enabled_modules || source?.subscription?.enabled_modules;
  return Array.isArray(raw) && raw.length ? raw : modulesForPlan(source?.plan || source?.subscription?.plan || "basic");
}

export function hasModule(source, module) {
  if (!module) return true;
  return enabledModules(source).includes(module);
}

export function subscribedModules(source) {
  const raw = source?.subscribed_modules || source?.subscription?.subscribed_modules;
  if (Array.isArray(raw) && raw.length) return raw;
  return enabledModules(source);
}

export function entitlements(source) {
  return source?.entitlements || source?.subscription?.entitlements || {};
}

export function hasFeature(source, feature) {
  if (!feature) return true;
  const features = entitlements(source).features;
  if (Array.isArray(features)) return features.includes(feature);
  if (feature === "loop") return hasModule(source, "loop");
  return hasModule(source, feature);
}

export function loopState(source) {
  const data = entitlements(source);
  return {
    eligible: data.loop_eligible !== false && subscribedModules(source).includes("loop"),
    enabled: data.loop_enabled === true || hasModule(source, "loop"),
    reason: data.loop_reason || "",
  };
}

export function roleModule(role) {
  if (["reception", "mechanic", "tester"].includes(role)) return "service";
  if (role === "shopkeeper") return "shop";
  return "";
}

export function moduleHome(user) {
  if (!user) return "/terminal";
  if (user.role === "platform_admin") return "/platform";
  if (hasModule(user, "billing") && !hasModule(user, "service") && !hasModule(user, "shop") && !hasModule(user, "inventory") && !hasModule(user, "hr")) return "/ledger";
  if (["admin", "tenant_admin", "branch_admin"].includes(user.role)) return "/admin";
  if (user.role === "shopkeeper" && hasModule(user, "shop")) return "/shopkeeper";
  if (["reception", "mechanic", "tester"].includes(user.role) && hasModule(user, "service")) return `/${user.role}`;
  if (hasModule(user, "shop")) return "/shop";
  if (hasModule(user, "billing")) return "/ledger";
  if (hasModule(user, "hr")) return "/employee";
  return "/admin";
}
